import { Pipe, PipeTransform } from '@angular/core';
import { SourceMapper } from 'src/app/utils/source-mapper.util';

@Pipe({
  name: 'sourceDisplayName'
})
export class SourceDisplayNamePipe implements PipeTransform {
  transform(source: string): string {
    return SourceMapper.toDisplayName(source);
  }
}

